module.exports = __webpack_public_path__ + "../resources/images/filepicker_sprite-d14919267e610250931b7464ec5d3cca.png";